
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/unsubscribe-page/[...path]",
      function () {
        return require("private-next-pages/s/unsubscribe-page/[...path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/unsubscribe-page/[...path]"])
      });
    }
  